import {Directionality} from "@angular/cdk/bidi";
import {CdkStepper} from "@angular/cdk/stepper";
import {ChangeDetectorRef, Component, ElementRef, OnInit} from "@angular/core";
import {ActivatedRoute} from "@angular/router";


@Component({
    selector: 'cdk-custom-stepper',
    templateUrl: './cdk-custom-stepper.html',
    styleUrls: ['./cdk-custom-stepper.scss'],
    providers: [{provide: CdkStepper, useExisting: CustomStepper}],
})
export class CustomStepper extends CdkStepper implements OnInit {
    label: boolean = true;
    lifeCycleStep: boolean = false;

    constructor(private dir: Directionality, private changeDetectorRef: ChangeDetectorRef, private elementRef: ElementRef, private route: ActivatedRoute) {
        super(dir, changeDetectorRef, elementRef);
    }

    ngOnInit(): void {
        this.route.queryParams.subscribe(params => {
            if ('id' in params) {
                this.lifeCycleStep = true;
            } else {
                this.lifeCycleStep = false;
            }
        });
    }

    collapsed = false;

    wow() {
        let w = document.getElementById("stepper")!.style.width;

        document.getElementById("stepper")!.style.width = "10%";
        document.getElementById("customStepper")!.classList.replace("relaxed", "focus");
        this.label = !this.label;
        this.collapsed = true;

        if (w === "10%") {
            document.getElementById("stepper")!.style.width = "25%";
            document.getElementById("customStepper")!.classList.replace("focus", "relaxed");
            this.collapsed = false;
        }

    }

    lastIndex = 0;

    selectStepByIndex(index: number): void {
        this.selectedIndex = index;
        if (index == 3) {
            this.wow()
            this.lastIndex = index;
        } else {
            if (this.lastIndex == 3) {
                this.wow();
                this.lastIndex = index;
            }
        }
    }

    triggerChange() {
        this.changeDetectorRef.detectChanges();
    }


}